const staffDepartmentManagement = () =>
  import('@/views/main/staff/department-management/department-management.vue')
export default {
  path: '/main/staff/departmentManagement',
  name: 'staffDepartmentManagement',
  component: staffDepartmentManagement,
  children: []
}
